import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Container, Row } from 'reactstrap';

import { Content, Title, Loading, Box } from './style';

import Messages from '../Messages';
import Logo from '../Logo';
import LoaddingImg from '../../assets/images/loading.gif';
import { IS_APP } from '../../services/target';

const ContentBox = ({ children, title, loading }) => (
  <Container id="_content-box">
    <Row className="justify-content-center align-items-center">
      <Box id="_box" md={{ size: 6, offset: 0 }} sm={{ size: 8, offset: 2 }}>
        <Logo height="100px" />
        <Messages />
        {loading ? (
          <Loading src={LoaddingImg} title="Carregando..." alt="Carregando..." />
        ) : (
          <Fragment>
            {!IS_APP && <Title>{title}</Title>}
            <Content>{children}</Content>
          </Fragment>
        )}
      </Box>
    </Row>
  </Container>
);

ContentBox.defaultProps = {
  loading: false,
};

ContentBox.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  title: PropTypes.string.isRequired,
  loading: PropTypes.bool,
};

export default ContentBox;



// WEBPACK FOOTER //
// ./src/components/ContentBox/index.js